/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography, breakpoints } from '@coursera/cds-core';

import { PlanGraduationPrompt } from 'bundles/degree-home/components/v3-dpm/components/PlanningTool/PlanGraduationPrompt';

import initialStateImage1 from 'images/degree-home/initial-state-image-1.svg';
import initialStateImage2 from 'images/degree-home/initial-state-image-2.svg';

import _t from 'i18n!nls/degree-home';

const styles = {
  initialStateContainer: css`
    display: flex;
    flex-direction: column;
    gap: var(--cds-spacing-400);
    margin: 0 var(--cds-spacing-600);
    align-items: center;

    ${breakpoints.up('lg')} {
      padding: 0 var(--cds-spacing-400);
    }

    img {
      max-width: 100%;
    }
  `,
  description: css`
    text-align: center;
  `,
};

const PlanningToolInitialState: React.FC = () => {
  return (
    <React.Fragment>
      {/* eslint-disable-next-line @coursera-web/custom-rules/prefer-cds-typography2 -- FIXME: legacy; migrate to Typography2 */}
      <Typography variant="h1semibold">{_t('My Graduation Plan')}</Typography>
      <PlanGraduationPrompt variant="academics" />
      <div css={styles.initialStateContainer}>
        {/* eslint-disable-next-line @coursera-web/custom-rules/prefer-cds-typography2 -- FIXME: legacy; migrate to Typography2 */}
        <Typography variant="h2" css={styles.description}>
          {_t('Add courses to your plan, view when course offerings change, and edit your plan anytime')}
        </Typography>

        <img src={initialStateImage1} alt="" aria-label={_t('empty plan image 1')} />
        <img src={initialStateImage2} alt="" aria-label={_t('empty plan image 2')} />
      </div>
    </React.Fragment>
  );
};

export default PlanningToolInitialState;
